<template>
  <div id="app" ref="app" :class="{'admin': $route.path === '/admin'}" :style="{'padding-bottom': $route.path !== '/admin' ? paddingBottom : 0}">
    <my-header ref="header" @on-show="showConsultationModal" v-if="$route.path !== '/admin' && $route.name !== 'notFound' && $route.name !== 'pdf1' && $route.name !== 'pdf2'" :style="{background: $route.path == '/' ? bgcOp : bgc}"/>
    <router-view :key="$route.path" @on-show="showConsultationModal" ref="body" :showGif="showGif" @on-init="initScroll"/>
    <my-footer @on-show="showConsultationModal" class="footer" ref="footer" v-if="$route.path !== '/admin' && $route.name !== 'notFound' && $route.name !== 'pdf1' && $route.name !== 'pdf2'"/>
    <!-- <icon-button v-if="$route.path !== '/admin' && $route.name !== 'pdf1' && $route.name !== 'pdf2'" @on-show="showConsultationModal"/> -->
    <consultation-modal
      @on-cancel="cancel"
      :isShow="isShowConsultationModal"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      paddingBottom: '395px',
      isShowConsultationModal: false,
      bgcOp: 'rgba(26, 31, 44, 0.5)',
      bgc: 'rgba(26, 31, 44, 1)',
      init: 0,
      showGif: false
    }
  },
  mounted() {
    if (this.$refs.footer) {
      this.paddingBottom = (this.$refs.footer.$el.offsetHeight - 1) + 'px'
    }
    window.onresize = () => {
      if (this.$refs.footer) {
        this.paddingBottom = (this.$refs.footer.$el.offsetHeight - 1) + 'px'
      }
    }
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.$refs.body.$refs.banner && this.$route.name !== 'home' && scrollTop > this.$refs.body.$refs.banner.offsetHeight - 68) {
        this.bgc = 'rgba(26, 31, 44, 1)'
      } else {
        this.bgc = 'rgba(26, 31, 44, 1)'
      }
      if (this.$refs.body.$refs.banner && this.$route.name === 'home') {
        let height = 0
        height = this.$refs.body.$refs.banner.offsetHeight
        let heightUp = height - 200
        let heightDown = height + 500
        if (scrollTop > heightUp && scrollTop < heightDown && this.$refs.body.$children[1].$refs.tips && this.$route.name === 'home' && this.init === 0) {
          this.showGif = true
          setTimeout(() => {
            this.$refs.body.$children[1].$refs.tips.style.display = 'block'
          }, 4100)
          this.init++
        }
      }
    }
  },
  methods: {
    showConsultationModal() {
      this.isShowConsultationModal = true
    },
    cancel() {
      this.isShowConsultationModal = false
    },
    initScroll() {
      if (this.$route.name == 'home') {
        this.init = 0
        this.showGif = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
#app
  user-select none
  font-family '微软雅黑', 'Avenir', Helvetica, Arial, simHei sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  min-height 100%
  position relative
  min-width 1200px
  .footer
    position absolute
    bottom 0
    left 0
  &.admin
    overflow-y auto
    background-color #19222e
    color iwhite
    font-size 14px
    color rgba(255,255,255,0.8)
</style>



// WEBPACK FOOTER //
// src/App.vue